import RUF from "../../../util/redux";

export function metaSetEditMode(state, action) {
  return RUF.updateObject(state, {
    meta: RUF.updateObject(state.meta, {
      inEditMode: action.payload
    })
  });
}
